import React, { ImgHTMLAttributes, useState } from 'react';

export const Image: React.FC<ImgHTMLAttributes<HTMLImageElement>> = (props) => {
    const [error, setError] = useState(false);
    if (error) return null;
    return (
        <img {...props} onError={() => { setError(true); }} />
    );
}
